export default __webpack_public_path__ + "static/media/amazon-store.4ab4aa5a.svg";